import React, { useState } from 'react';
import ReportProblemModal from './ReportProblemModal';

const ReportProblemButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className="text-sm text-neutral-500 hover:text-neutral-700 underline"
      >
        Report a Problem
      </button>
      {showModal && <ReportProblemModal onClose={() => setShowModal(false)} />}
    </>
  );
};

export default ReportProblemButton;
